import React, { Component } from "react";
import { connect } from "react-redux";
import PageWrapper from "../../components/PageWrapper";
import WhiteBox from "../../components/WhiteBox";
import { Preloader } from "../../components/Chart/index";
import Multi from "../../components/Multi";
import debounce from "lodash/debounce";
import "./style.css";
import axios from "axios";
import ReactTooltip from "react-tooltip";
import "react-circular-progressbar/dist/styles.css";
import { getDmp, getDmpProduct, uniqueDmps } from "../../lib/format-dmps";
import { RangeSelector } from "../revenue/range-selector";
import moment from "moment";
import {
  formatNumber,
  getPercentage,
  numberWithCommas
} from "../../lib/format-number";
import { dayStart, dayEnd, earlierDate } from "../../lib/format-date";

class SyncsAudience extends Component {
  debouncedFilter = null;
  state = {
    size: 20,
    offset: 0,
    filter: "",
    sort: "creation",
    sortOrder: "desc",
    objectId: "",
    transactionId: "",
    events: [],
    loading: false,

    dmpFilter: ["ar"],
    dmpOptions: ["ddp", "ar"],

    lastEvaluatedKey: null,
    range: {
      type: "current",
      startDate: null,
      endDate: null
    }
  };

  constructor(props) {
    super(props);

    let search = window.location.search;
    let params = new URLSearchParams(search);
    console.log("events query params", params, params.get("transactionId"));
  }

  componentDidMount() {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    console.log("events query params", params, params.get("transactionId"));

    if (params.get("transactionId") && params.get("transactionId") != "") {
      this.setState({ filter: params.get("transactionId") });
    }

    //
    // handle range date passed from import page, if any
    let range = {
      type: "current",
      startDate: null,
      endDate: null
    };
    if (this.props.location && this.props.location.state) {
      range = JSON.parse(this.props.location.state.range);

      if (range.type === "custom") {
        range.startDate = moment(range.startDate);
        range.endDate = moment(range.endDate);
      }

      console.log("range passed", range);
    }

    axios.get("/dmpDetails").then(response => {
      console.log("dmp list", response, response.data.body);

      let data = response.data.body;
      let dmpList = uniqueDmps(data, false, false);
      dmpList = dmpList.map(el => el.dmp);
      console.log("dmpList:", dmpList);

      this.setState(
        {
          dmpOptions: dmpList,
          transactionId: params.get("transactionId") || "",
          range: range
        },
        () => {
          this.loadEventUploadDetails(
            this.state.filter,
            this.state.size,
            this.state.offset,
            this.state.sort,
            this.state.sortOrder,
            this.state.objectId,
            this.state.transactionId,
            null,
            this.state.range
          );
          this.debouncedFilter = debounce(this.loadEventUploadDetails, 1000);
        }
      );
    });
  }

  onFilterChange(target) {
    console.log("onFilterChange", target.value, this);
    let offset = 0;
    this.setState(
      {
        events: [],
        offset: offset,
        filter: target.value,
        lastEvaluatedKey: null
      },
      () => {
        this.debouncedFilter(
          target.value,
          this.state.size,
          offset,
          this.state.sort,
          this.state.sortOrder,
          this.state.objectId,
          this.state.transactionId,
          null,
          this.state.range
        );
      }
    );
  }
  onLoadMore() {
    let lastEvaluatedKey = this.state.lastEvaluatedKey;
    let offset = this.state.offset + this.state.size;
    this.setState({ offset: offset, lastEvaluatedKey: null }, () => {
      this.loadEventUploadDetails(
        this.state.filter,
        this.state.size,
        offset,
        this.state.sort,
        this.state.sortOrder,
        this.state.objectId,
        this.state.transactionId,
        lastEvaluatedKey,
        this.state.range
      );
    });
  }

  filterTransactionId(event) {
    console.log("filterTransactionId", event);
    this.setState(
      {
        objectId: event.objectId,
        transactionId: event.transactionId,
        offset: 0
      },
      () => {
        this.loadEventUploadDetails(
          this.state.filter,
          this.state.size,
          this.state.offset,
          this.state.sort,
          this.state.sortOrder,
          this.state.objectId,
          this.state.transactionId
        );
      }
    );
  }

  // call api for fetching event details
  loadEventUploadDetails(
    filter = "",
    size = 10,
    offset = 0,
    sort = "creation",
    sortOrder = "asc",
    objectId = "",
    transactionId = "",
    lastEvaluatedKey = null,
    range = null
  ) {
    const { start, end } = this.findStartEnd(range);

    console.log(
      "loadEventUploadDetails: ",
      filter,
      size,
      offset,
      sort,
      sortOrder,
      objectId,
      transactionId,
      lastEvaluatedKey,
      JSON.stringify(lastEvaluatedKey)
    );
    let dmpFilterStr = this.state.dmpFilter.join(",");
    // first reset then load data
    this.setState({ loading: true }, () => {
      axios
        .get(
          "/event/sync/audience?keyType=tx_id&key=" +
            this.state.filter +
            "&dmpFilter=" +
            dmpFilterStr +
            "&lastEvaluatedKey=" +
            encodeURIComponent(JSON.stringify(lastEvaluatedKey))
          /*+
                                                                '&startDate=' +
                                                                start +
                                                                '&endDate=' +
                                                                end
                                                                */
        )
        .then(response => {
          console.log("list", response, response.data.body);
          let newEvents = response.data.body;

          console.log("events", newEvents);
          let oldEvents = this.state.events;
          oldEvents = oldEvents.concat(newEvents);
          let _lastEvaluatedKey =
            response.data.body && response.data.body.length > 0
              ? response.data.body[0].lastEvaluatedKey
              : null;
          this.setState({
            events: oldEvents,
            lastEvaluatedKey: _lastEvaluatedKey,
            loading: false
          });
        });
    });
  }

  getPercentage(num) {
    //return parseFloat(num).toFixed(2);
    let n = parseFloat(num).toFixed(0);
    if (n === "NaN") return "0";
    return n > 100 ? 100 : n;
  }

  getMatchrate(num) {
    let n = parseFloat(num).toFixed(0);
    if (n === "NaN") return "Low";
    if (n >= 75) return "High";
    if (n <= 75 && n >= 35) return "Good";
    return "Low";
  }

  getFilesJoinStr(event) {
    let str =
      event.files &&
      Object.keys(event.files)
        .map(el => el.substring(el.lastIndexOf("/") + 1))
        .join(", ");

    // truncate long str
    if (str.length > 100) str = str.substring(0, 100) + "...";
    return str;
  }
  getFilesJoinHtml(event) {
    let arr = [<h3>Files processed</h3>];
    Object.keys(event.files)
      //.map(el => el.substring(el.lastIndexOf('/') + 1))
      .map(el => arr.push(<li>{el}</li>));

    return arr;
  }
  getStatus(event) {
    // completitions
    if (event.done >= event.todo) {
      return {
        status: "Completed",
        description: "Total jobs: " + event.done + " of " + event.todo
      };
    } else {
      return {
        status: "Running",
        description:
          "Running Jobs: " + event.done + " of " + event.todo + " submitted"
      };
    }
  }
  getStatusRender(event) {
    const html = [];

    let summaryStatus = this.getStatus(event);
    console.log("summaryStatus:", summaryStatus);

    let uuid =
      event.txId + "_" + event.destination + "_" + new Date().getTime();
    html.push(
      <ReactTooltip id={"summaryTooltip" + uuid} type="dark" effect="solid">
        <h3>Status</h3>
        <div>{summaryStatus.description}</div>
      </ReactTooltip>
    );

    if (summaryStatus.status === "Completed") {
      html.push(
        <span
          data-tip
          data-for={"summaryTooltip" + uuid}
          className="badge badge-success"
        >
          {summaryStatus.status}
        </span>
      );
    } else if (summaryStatus.status === "Completed with errors") {
      html.push(
        <span
          data-tip
          data-for={"summaryTooltip" + uuid}
          className="badge badge-warning"
        >
          {summaryStatus.status}
        </span>
      );
    } else {
      html.push(
        <span
          data-tip
          data-for={"summaryTooltip" + uuid}
          className="badge badge-secondary"
        >
          {summaryStatus.status}
        </span>
      );
    }

    return html;
  }

  onChangeDmpFilter(dmp) {
    console.log("change dmp filter ", dmp);
    let dmpFilter = this.state.dmpFilter;
    if (dmpFilter.indexOf(dmp) == -1) dmpFilter.push(dmp);
    else dmpFilter.splice(dmpFilter.indexOf(dmp), 1);

    console.log("change dmp filter state:  ", dmpFilter);
    this.setState({ dmpFilter: dmpFilter, events: [], offset: 0 }, () => {
      this.loadEventUploadDetails(
        this.state.filter,
        this.state.size,
        this.state.offset,
        this.state.sort,
        this.state.sortOrder,
        this.state.objectId,
        this.state.transactionId,
        null,
        this.state.range
      );
    });
  }

  findStartEnd(range) {
    let start, end;

    switch (range.type) {
      case "custom":
        start = dayStart(range.startDate).format("YYYY-MM-DD");
        end = earlierDate(dayEnd(range.endDate), moment()).format("YYYY-MM-DD");
        break;
      case "last":
        const month = moment().month();
        start = dayStart(
          moment()
            .month(month - 1)
            .date(1)
        ).format("YYYY-MM-DD");
        end = dayEnd(moment().date(0)).format("YYYY-MM-DD");
        break;
      case "current":
      default:
        start = dayStart(moment().date(1)).format("YYYY-MM-DD");
        end = moment().format("YYYY-MM-DD");
        break;
    }

    return { start, end };
  }

  handleRangeChange(newRange) {
    const oldRange = this.state.range;

    if (newRange.type !== "custom" && newRange.type === oldRange.type) return;
    else if (
      newRange.type === "custom" &&
      newRange.startDate === oldRange.startDate &&
      newRange.endDate === oldRange.endDate
    )
      return;

    this.setState({ events: [], offset: 0, range: newRange }, () => {
      this.loadEventUploadDetails(
        this.state.filter,
        this.state.size,
        this.state.offset,
        this.state.sort,
        this.state.sortOrder,
        this.state.objectId,
        this.state.transactionId,
        null,
        newRange
      );
    });
  }

  onBackCliked() {
    this.props.history.goBack();
  }

  render() {
    return (
      <PageWrapper>
        <div className="container-fluid">
          <Multi>
            <div className="row">
              <div className="col-lg-12">
                <button
                  className="border-button inlinebuttons"
                  onClick={() => this.onBackCliked()}
                >
                  <i className="fa fa-chevron-left"></i>&#160;BACK
                </button>
              </div>
            </div>

            <div className="row" style={{ marginTop: "10px" }}>
              <div className="col-lg-12">
                <WhiteBox customStyle={{ overflow: "visible" }}>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <h3 className="box-title">Syncs Audiences Events:</h3>
                    <div style={{ flex: 1 }} />

                    <div className="text-right">
                      <div
                        className="btn-group btn-group-toggle"
                        data-toggle="buttons"
                        style={{ left: "-10px" }}
                      >
                        <button
                          key="check_ar"
                          className="btn btn-primary active"
                          onClick={() => this.onChangeDmpFilter("ar")}
                        >
                          AR
                        </button>

                        {this.state.dmpOptions &&
                          this.state.dmpOptions.indexOf("ddp") != -1 && (
                            <button
                              key="check_ddp"
                              className="btn btn-primary"
                              onClick={() => this.onChangeDmpFilter("ddp")}
                            >
                              Google
                            </button>
                          )}

                        {this.state.dmpOptions &&
                          this.state.dmpOptions.indexOf("adform") != -1 && (
                            <button
                              key="check_ddp"
                              className="btn btn-primary"
                              onClick={() => this.onChangeDmpFilter("adform")}
                            >
                              Adform
                            </button>
                          )}
                      </div>
                    </div>
                  </div>

                  {/*
                                    <RangeSelector range={this.state.range} onChangeRange={range => this.handleRangeChange(range)} />
                                    */}

                  {this.state.loading && this.state.events.length === 0 ? (
                    <Preloader transparent />
                  ) : (
                    <div>
                      {this.state.events.length > 0 && (
                        <table className="segment-list segment-list--table">
                          <thead>
                            <tr className="audience-list audience-list--header">
                              <th
                                className="audience-list audience-list--audience pointer"
                                style={{ width: "150px" }}
                              >
                                Transaction Id
                              </th>
                              <th
                                className="audience-list audience-list--audience pointer"
                                style={{ width: "150px" }}
                              >
                                Audience Id
                              </th>
                              <th className="audience-list audience-list--creation pointer">
                                Last Updated
                              </th>
                              <th className="audience-list audience-list--creation">
                                Matchrate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.events.map(event => {
                              const totalSync = event.syncOk + event.syncError;
                              const matchrate = this.getMatchrate(
                                (event.syncOk /
                                  (event.executionType === "STEP_FUNCTION"
                                    ? totalSync
                                    : event.rows)) *
                                  100.0
                              );
                              return (
                                <tr
                                  key={
                                    "row-data-" +
                                    event.txId +
                                    "-" +
                                    event.destination
                                  }
                                  className={`audience-list audience-list--row`}
                                >
                                  <td className="audience-list audience-list--audience">
                                    <a
                                      href={
                                        "/imports?transactionId=" + event.txId
                                      }
                                    >
                                      {event.txId}
                                    </a>
                                  </td>
                                  <td className="audience-list audience-list--audience">
                                    <a
                                      href={
                                        "/audiences?filter=" + event.audienceId
                                      }
                                    >
                                      {event.audienceId}
                                    </a>
                                  </td>
                                  <td className="audience-list audience-list--creation">
                                    <span>
                                      {new Date(
                                        event.creation
                                      ).toLocaleString()}
                                    </span>
                                  </td>
                                  <td className="audience-list audience-list--creation">
                                    {event.syncOk > 0 && (
                                      <div className="row">
                                        <div
                                          className="col"
                                          style={{ cursor: "pointer" }}
                                        >
                                          <ReactTooltip
                                            id={
                                              "destinationDmpTooltip" +
                                              event.txId +
                                              "-" +
                                              event.audienceId +
                                              "-" +
                                              event.destination +
                                              "_0"
                                            }
                                            type="dark"
                                            effect="solid"
                                          >
                                            <h3>
                                              DMP:{" "}
                                              {event.destination === "ar"
                                                ? "Audiencerate"
                                                : getDmp(event.destination)}
                                            </h3>
                                            <div>
                                              IDs found in Matchtable:{" "}
                                              {numberWithCommas(
                                                event.rowsMatched
                                              )}{" "}
                                              of {numberWithCommas(event.rows)}
                                            </div>
                                            <div>
                                              Sync OK:{" "}
                                              {numberWithCommas(event.syncOk)}{" "}
                                              of{" "}
                                              {numberWithCommas(
                                                event.executionType ===
                                                  "STEP_FUNCTION"
                                                  ? totalSync
                                                  : event.rowsMatched
                                              )}
                                            </div>
                                            <div>
                                              Syncs in Error:{" "}
                                              {numberWithCommas(
                                                event.syncError
                                              )}{" "}
                                              of{" "}
                                              {numberWithCommas(
                                                event.executionType ===
                                                  "STEP_FUNCTION"
                                                  ? totalSync
                                                  : event.rowsMatched
                                              )}
                                            </div>
                                          </ReactTooltip>

                                          <div
                                            data-tip
                                            data-for={
                                              "destinationDmpTooltip" +
                                              event.txId +
                                              "-" +
                                              event.audienceId +
                                              "-" +
                                              event.destination +
                                              "_0"
                                            }
                                          >
                                            <div
                                              style={{
                                                verticalAlign: "middle",
                                                marginTop: "10px"
                                              }}
                                            >
                                              <b style={{ fontWeight: "bold" }}>
                                                {event.destination === "ar"
                                                  ? "AR"
                                                  : getDmp(event.destination)}
                                              </b>
                                              <p style={{ fontSize: "16px" }}>
                                                {matchrate}

                                                <span
                                                  className={
                                                    matchrate === "High"
                                                      ? "fa fa-angle-double-up"
                                                      : matchrate === "Low"
                                                      ? "fa fa-angle-down"
                                                      : "fa fa-angle-up"
                                                  }
                                                  style={{
                                                    top: "2px",
                                                    position: "relative",
                                                    left: "3px",
                                                    color:
                                                      matchrate === "Low"
                                                        ? "#ffc107"
                                                        : "#27a745",
                                                    fontSize: "20px"
                                                  }}
                                                ></span>
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}

                            {this.state.loading && (
                              <tr>
                                <td colSpan={5} style={{ textAlign: "center" }}>
                                  <button
                                    type="button"
                                    disabled
                                    className="btn btn-link property-list property-list--load-more-button"
                                  >
                                    Loading...
                                  </button>
                                </td>
                              </tr>
                            )}

                            {!this.state.loading &&
                              this.state.events.length >=
                                this.state.offset + this.state.size && (
                                <tr>
                                  <td
                                    colSpan={5}
                                    style={{ textAlign: "center" }}
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-link property-list property-list--load-more-button"
                                      onClick={this.onLoadMore.bind(this)}
                                    >
                                      Load more
                                    </button>
                                  </td>
                                </tr>
                              )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  )}

                  {this.state.events.length == 0 && (
                    <div className="empty-page">
                      <h2 className="empty-page empty-page--title">
                        No events found.
                      </h2>
                    </div>
                  )}
                </WhiteBox>
              </div>
            </div>
          </Multi>
        </div>
      </PageWrapper>
    );
  }
}

export default connect(
  state => ({}),
  {}
)(SyncsAudience);
